(function () {
  if (window.JatkaCompanyPurchaseReady) return;
  window.JatkaCompanyPurchaseReady = true;

  function cleanNip(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 10);
  }

  function isValidPolishNip(value) {
    var digits = cleanNip(value);
    if (digits.length !== 10 || /^(\d)\1{9}$/.test(digits)) return false;
    var weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    var sum = 0;

    for (var index = 0; index < weights.length; index += 1) {
      sum += Number(digits.charAt(index)) * weights[index];
    }

    var control = sum % 11;
    return control !== 10 && control === Number(digits.charAt(9));
  }

  function getElements(root) {
    return {
      root: root,
      toggle: root.querySelector('[data-jatka-company-toggle]'),
      fields: root.querySelector('[data-jatka-company-fields]'),
      nip: root.querySelector('[data-jatka-company-nip]'),
      error: root.querySelector('[data-jatka-company-error]'),
      status: root.querySelector('[data-jatka-company-status]'),
      terms: root.querySelector('[data-jatka-cart-terms]'),
      termsError: root.querySelector('[data-jatka-cart-terms-error]')
    };
  }

  function getVisibleRoot(target) {
    var localRoot = target && target.closest ? target.closest('[data-jatka-company-purchase]') : null;
    if (localRoot) return localRoot;

    var roots = document.querySelectorAll('[data-jatka-company-purchase]');
    for (var index = 0; index < roots.length; index += 1) {
      if (roots[index].getClientRects().length) return roots[index];
    }

    return roots[0] || null;
  }

  function validate(elements, showError) {
    if (!elements.toggle.checked) return true;
    var valid = isValidPolishNip(elements.nip.value);
    elements.error.hidden = valid || !showError;
    elements.nip.setAttribute('aria-invalid', valid ? 'false' : 'true');
    return valid;
  }

  async function saveAttributes(elements) {
    var companyPurchase = elements.toggle.checked;
    var nip = companyPurchase ? cleanNip(elements.nip.value) : '';
    var rootPath = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    var response = await fetch(rootPath + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Jatka - zakup firmowy': companyPurchase ? 'Tak' : '',
          'Jatka - NIP': nip,
          'Jatka - akceptacja regulaminu': elements.terms && elements.terms.checked ? 'Tak' : ''
        }
      })
    });

    if (!response.ok) throw new Error('Nie udało się zapisać danych firmy. Spróbuj ponownie.');
  }

  document.addEventListener('change', async function (event) {
    var toggle = event.target.closest('[data-jatka-company-toggle]');
    var termsInput = event.target.closest('[data-jatka-cart-terms]');
    var nipInput = event.target.closest('[data-jatka-company-nip]');
    var root = getVisibleRoot(event.target);
    if (!root || (!toggle && !nipInput && !termsInput)) return;

    var elements = getElements(root);
    if (termsInput) {
      elements.termsError.hidden = true;
      elements.terms.setAttribute('aria-invalid', 'false');
      return;
    }
    if (toggle) {
      elements.fields.hidden = !elements.toggle.checked;
      elements.error.hidden = true;
      elements.status.textContent = '';
      if (!elements.toggle.checked) elements.nip.value = '';

      try {
        await saveAttributes(elements);
        if (elements.toggle.checked) elements.nip.focus();
      } catch (error) {
        elements.status.textContent = error.message;
      }
      return;
    }

    if (!validate(elements, true)) return;
    try {
      await saveAttributes(elements);
    } catch (error) {
      elements.status.textContent = error.message;
    }
  });

  document.addEventListener('input', function (event) {
    var nipInput = event.target.closest('[data-jatka-company-nip]');
    if (!nipInput) return;

    var root = getVisibleRoot(event.target);
    var elements = getElements(root);
    elements.nip.value = cleanNip(elements.nip.value);
    elements.error.hidden = true;
    elements.nip.setAttribute('aria-invalid', 'false');
    elements.status.textContent = '';
  });

  async function handleCompanyCheckout(event, checkout) {
    var root = getVisibleRoot(checkout);
    if (!root) return;
    var elements = getElements(root);
    if (elements.terms && !elements.terms.checked) {
      event.preventDefault();
      event.stopPropagation();
      elements.termsError.hidden = false;
      elements.terms.setAttribute('aria-invalid', 'true');
      elements.terms.focus();
      return;
    }
    if (!elements.toggle.checked) return;

    event.preventDefault();
    event.stopPropagation();
    if (!validate(elements, true)) {
      elements.nip.focus();
      return;
    }

    if (window.JatkaCompanyCheckoutBusy) return;
    window.JatkaCompanyCheckoutBusy = true;
    checkout.setAttribute('aria-disabled', 'true');

    try {
      await saveAttributes(elements);
      var rootPath = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      window.location.assign(rootPath + 'checkout');
    } catch (error) {
      elements.status.textContent = error.message;
      checkout.removeAttribute('aria-disabled');
      window.JatkaCompanyCheckoutBusy = false;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
      if (!checkout) return;
      handleCompanyCheckout(event, checkout);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var checkout = event.submitter;
      if (!checkout || !checkout.matches('button[name="checkout"], input[name="checkout"]')) return;
      handleCompanyCheckout(event, checkout);
    },
    true
  );
})();
